"use strict";
/**
 * 定数
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINE_TYPE = exports.TIME_ZONE = exports.CONSTRUCTION_TYPE = exports.DEFAULT_MIN_PRICE = void 0;
/**
 * デフォルトの最小価格
 */
exports.DEFAULT_MIN_PRICE = 35000;
/**
 * 施工の種類 slug: 施工現場
 */
exports.CONSTRUCTION_TYPE = {
    'parking-construction': '駐車場工事',
    'road-construction': '道路工事'
};
/**
 * 施工の時間帯
 */
exports.TIME_ZONE = {
    0: '昼',
    1: '夜'
};
/**
 * 施工のラインの種類
 */
exports.LINE_TYPE = {
    WHITE: '白',
    WHITE_YELLOW: '白黄'
};
